import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useTranslation } from 'react-i18next';
import type { VisibilityReportContextGap } from '@brand24-original/llm-types';
import ReportSection from './ReportSection';
import { keywordsTemplate } from '../../helpers/ColumnHelper';

/** Tyle marek pokazuje kolumna, reszta chowa się pod „+N" — jak w zakładce Context. */
const VISIBLE_BRANDS = 5;

interface ReportContextGapsProps {
  gaps: VisibilityReportContextGap[];
}

/**
 * Tematy, w których marki nie ma, a konkurenci są. Tabela jest odwzorowaniem sekcji „Context Gap"
 * z zakładki Context — te same kolumny, te same żetony marek i ta sama lista (konkurenci, nie
 * ranking wszystkich marek w temacie). Bez paginacji i rozwijanych opisów: raport jest dokumentem.
 */
export const ReportContextGaps: React.FC<ReportContextGapsProps> = ({ gaps }) => {
  const { t } = useTranslation();

  // Slajd bez danych w ogóle nie wchodzi do raportu — projekt może nie mieć jeszcze insightów.
  if (gaps.length === 0) {
    return null;
  }

  return (
    <ReportSection
      title={t('reportGapsTitle')}
      titleAccent={t('reportGapsTitleAccent')}
      subtitle={t('reportGapsSubtitle')}
    >
      <DataTable
        stripedRows
        value={gaps}
        dataKey="topic"
        tableClassName="table"
        className="table-wrapper"
        tableStyle={{ tableLayout: 'auto' }}
      >
        <Column
          header={t('topic')}
          field="topic"
          headerClassName="table__header"
          body={(gap: VisibilityReportContextGap) => (
            <div className="topic-name" style={{ display: 'flex', alignItems: 'center', fontWeight: '600' }}>
              {gap.topic}
            </div>
          )}
          style={{ width: '220px' }}
        />
        <Column
          header={t('topBrands')}
          headerClassName="table__header"
          body={(gap: VisibilityReportContextGap) => (
            <div className="tags">
              {keywordsTemplate(gap.topBrands, VISIBLE_BRANDS, 'tag tag--brand', '')}
            </div>
          )}
          style={{ minWidth: '150px' }}
        />
        <Column
          header={t('occurrences')}
          field="occurrences"
          headerClassName="table__header table__header--center"
          bodyClassName="table__cell--center"
          style={{ width: '140px' }}
        />
      </DataTable>
    </ReportSection>
  );
};

export default ReportContextGaps;
